<template>
  <v-carousel
    hide-delimiter-background
    cycle
    hide-controls
    hide-delimiters
    :show-arrows="false"
    v-if="items.length"
    class="mb-4"
    :key="locale"
  >
    <v-carousel-item
      v-for="(item, i) in items"
      :key="`${locale}-${i}`"
    >
      <a
        class="banner-link"
        :href="item.link"
        target="_blank"
        rel="noopener"
        @click.stop
      >
        <v-img :src="item.srcWithLang" cover />
      </a>
    </v-carousel-item>
  </v-carousel>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const { tm, locale } = useI18n()

const items = computed(() => {
  const arr = tm('carouselItems')
  if (!Array.isArray(arr)) return []
  const lng = String(locale.value)

  return arr.map(it => {
    const base = it.src.startsWith('/') ? it.src : '/' + it.src
    const bust = base.includes('?') ? `${base}&lng=${lng}` : `${base}?lng=${lng}`
    return {
      ...it,
      srcWithLang: bust,
      link: it.link
    }
  })
})
</script>

<style scoped>
.banner-link {
  display: block;
  cursor: pointer;
}
.banner-link :deep(img),
.banner-link :deep(.v-img) {
  cursor: inherit;
}

@media (max-width: 600px) {
  .v-carousel { max-height: 180px; }
}
</style>
